import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/storage';


 const firebaseConfig = {
    apiKey: "AIzaSyBmBxVehnXAlFHXjGIcNpysucDSGnM-dIY",
    authDomain: "myslack2094.firebaseapp.com",
    databaseURL: "https://myslack2094.firebaseio.com",
    projectId: "myslack2094",
    storageBucket: "myslack2094.appspot.com",
    messagingSenderId: "824661498880",
    appId: "1:824661498880:web:c08dcc146f01ec995b8ce5",
    measurementId: "G-DR1Z8Q8B45"
  };
  firebase.initializeApp(firebaseConfig);
  export default firebase;


// WEBPACK FOOTER //
// ./src/firebase.js